import { NodeData_Increment, NodeInterface } from "@swivl-mono/types";
import UserVariablesDropdown from "../../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import VarsModel from "../../../../../Models/Variables/VarsModel.Model";

import TabNodeLayoutData, { TabNodePositionalData } from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";
import { RandomId, StringHelper } from "@swivl-mono/helpers";



const IncrementNode = {
    Type: "increment",
    Empty: function () {
        return {
            "id": RandomId(6),
            "type": IncrementNode.Type,
            "variableId": undefined,
            "goto": undefined,
            "amount": 1,
        } as NodeData_Increment
    },

    PlumbData: function (node:NodeInterface) {


        const variable = (node.variableId && node.variableId.length) ? "#*" + node.variableId + "*#" : "Unset"
        let title =  StringHelper.trimStringToLengthWithElipsis(VarsModel.replaceVariableNameInString(variable), 20)
        
        return TabNodeLayoutData({
            node: node,
            label: node.amount > 0 ? "Increment" : "Decrement",
            title: title,
            body: node.amount,
            titleHeight: 45,
            baseWidth: 150,
            tabs: [  {  id: "goto", source: "goto", target: node.goto, },
        ]
        });

    },


    InspectorPanel: class IncrementInspectorPanel extends NodePanel {
        // constructor(props) {
        //     super(props);

            
        // }
       
        

        render() {
            const node = this.props.node as NodeData_Increment;


            return (<div>
                <div className="panel TableSaveRowPanel">
                    <InspectorNodeHeader title="Increment" id={node.id} />
                    <UserVariablesDropdown
                        onChange={this.onChange}
                        skipUserId={true}
                        name="variableId" 
                        value={node.variableId}
                        skipBotVariables={true}
                        />
                     
                    <label>Amount</label><br/>
                    <input type="number" name="amount" value={node.amount} onChange={this.onChange} />
                   
                   

                    <InspectorFooter deleteNode={this.deleteNode} node={this.props.node} />
                </div>

            </div>);
        }
    }
}
export default IncrementNode;

